import { PythonTopic } from '../../../../types/python-topic';
import { introduccionExercises } from './exercises';

export const introduccionTopic: PythonTopic = {
  id: -2,
  title: 'Introducción',
  description: 'Fundamentos de Python: variables, operadores, condicionales, ciclos, números, strings y listas básicas.',
  theory: `# Introducción a Python

## ¿Qué es Python?

Python es un lenguaje de programación de alto nivel, interpretado y de propósito general. Es conocido por su sintaxis clara y legible, lo que lo hace ideal para principiantes.

## Características principales

- **Interpretado**: No necesita compilación, se ejecuta directamente
- **Multiplataforma**: Funciona en Windows, Mac, Linux
- **Tipado dinámico**: No necesitas declarar el tipo de variable
- **Gran ecosistema**: Miles de librerías disponibles
- **Sintaxis clara**: Código fácil de leer y escribir

## Estructura de esta sección

En esta sección aprenderás los conceptos fundamentales de Python:

1. **Variables y tipos básicos**: Cómo almacenar información
2. **Operadores y expresiones**: Cómo realizar cálculos y comparaciones
3. **Print y salida**: Cómo mostrar información al usuario
4. **Condicionales**: Cómo tomar decisiones en tu código
5. **Ciclos**: Cómo repetir código múltiples veces
6. **Números**: Trabajar con enteros y flotantes
7. **Strings**: Manipular texto
8. **Listas básicas**: Almacenar colecciones de datos


Cada ejercicio incluye teoría expandida, ejemplos prácticos y ejercicios para que puedas practicar a tu propio ritmo. Los ejercicios en esta sección tienen validación flexible - solo necesitas que tu código se ejecute correctamente.`,
  difficulty: 'beginner',
  exercises: introduccionExercises
};

